<div
  class="flex flex-row flex-wrap gap-4"
  [formGroup]="datePickers.formGroup"
>
  <pr-query-scope-form
    #queryScopeForm="prQueryScopeForm"
    [dataSource]="dataSource$ | async"
    [scopeForms]="queryScopeForms"
    (formChange)="formData$.next($event)"
    (dateRangeChange)="dateRangeChange.emit($event)"
  />

  @if (datePickers.dateFilters().length > 0) {
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Select Date</mat-label>
      <input matInput formControlName="date" [matDatepicker]="picker" />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
        [disabled]="isViewingHistoricalRun()"
      />
      <mat-datepicker #picker />
    </mat-form-field>
  }

  @if (datePickers.dateRangeFilters().length > 0) {
    <pt-date-range-form
      dateLabel="Select Date Range"
      [useRangePicker]="true"
      [from]="datePickers.formGroup.value.dateFrom"
      [to]="datePickers.formGroup.value.dateTo"
      [disabled]="isViewingHistoricalRun()"
      (changed)="datePickers.setDateRange($event)"
    />
  }

  @if (!isViewingHistoricalRun()) {
    <pt-loader-button
      class="flex min-w-[200px] flex-row"
      color="primary"
      type="flat"
      [loading]="store.isLoading$ | async"
      [disabled]="disabled || queryScopeForm.rootForm.invalid"
      (click)="submit(false)"
    >
      <span [ngClass]="{ 'animate-pulse': promptToRun$ | async }">
        Run Report
      </span>
    </pt-loader-button>
  }
</div>
